import { OAuthProvider, signInWithPopup } from "firebase/auth";
import { firebaseAuth } from "./firebaseAuth";

const microsoftProvider = new OAuthProvider("microsoft.com");
microsoftProvider.setCustomParameters({
    prompt: "select_account"
});
export const signInWithMicrosoftPopup = () => signInWithPopup(firebaseAuth, microsoftProvider);